module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic04.16f4902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic04.png
// module id = 538
// module chunks = 1